$(document).ready(function () {
  document.querySelectorAll(".copy").forEach((item) => {
    item.addEventListener("click", (event) => {
      const textToCopy =
        item.parentNode.querySelector(".text-to-copy").textContent ||
        item.parentNode.querySelector(".text-to-copy").value;
      navigator.clipboard.writeText(textToCopy);
      updateTooltipWording(item);
    });
  });
});

function updateTooltipWording(item) {
  let tooltipContainer = item;

  tooltipContainer.setAttribute(
    "data-bs-original-title",
    "Copié dans le presse-papier"
  );

  let btnTooltip = bootstrap.Tooltip.getInstance(tooltipContainer);
  btnTooltip.show();

  tooltipContainer.setAttribute("data-bs-original-title", "Copier");
}
